import { testimonials } from "@/mocks/gossipData";

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-heart-line"></i>
              关于我们与口碑
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              我们在做的，是帮你把时间
              <span className="text-primary-600">花在值得看的瓜上</span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              吃瓜大全成立于三年前，起源于一群追综艺、看好剧、爱聊天的朋友对「好内容被埋没」的不甘。
              我们不追哗众取宠的流量，而是像挑西瓜一样，敲一敲、掂一掂，只为把那些真正皮薄瓤甜、值得一吃的精华内容递到你面前。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              这里没有标题党，也没有引战帖，只有编辑部与千万网友一起，认真筛选出的高赞精华帖、热门推荐与年度精选合集。
              愿你在每个想放松的时刻，都能在这里吃到一颗甜甜的瓜。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {[
                { icon: "ri-filter-3-line", t: "严选态度", d: "宁可少，不可滥" },
                { icon: "ri-verified-badge-line", t: "内容真实", d: "交叉核验来源" },
                { icon: "ri-user-heart-line", t: "尊重讨论", d: "不做恶意引战" },
              ].map((f) => (
                <div key={f.t} className="rounded-2xl border border-background-200/70 bg-background-100/50 p-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className={`${f.icon} text-xl`}></i>
                  </div>
                  <div className="mt-3 font-medium text-foreground-950">{f.t}</div>
                  <div className="mt-1 text-xs text-foreground-600">{f.d}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {testimonials.map((t, i) => (
              <figure
                key={t.name}
                className={`rounded-2xl border border-background-200/70 bg-background-50 p-5 ${
                  i % 2 === 1 ? "sm:translate-y-6" : ""
                }`}
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-sm ${j < t.rating ? "ri-star-fill" : "ri-star-line text-background-300"}`}
                    ></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-3-line"></i>
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}